export default {
  computed: {
    viewLimitDateFrom : function (){
      let date = new Date();
      // 3ヶ月前
      date.setMonth(date.getMonth() - 3);
      return date;
    },
  },
};